import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {login, updateTmpUser} from 'actions';

class SigninForm extends React.Component {
    constructor(props) {
        super(props);
        const username = localStorage ? localStorage.getItem('username') : '';
        const remember_me = localStorage ? localStorage.getItem('remember_me') : '';

        this.state = {
        	username,
          remember_me: remember_me == 'true',
        	password : "",
        	errors : [],
        	messages : []
        }
        this.displayName = 'SigninForm';
        this.handleChange = this.handleChange.bind(this);
        this.signin = this.signin.bind(this);
    }
    toggleRememberMe() {
      this.setState({ remember_me: !this.state.remember_me });

      if(localStorage) {
        localStorage.setItem('remember_me', this.state.remember_me ? 'false' : 'true');
      }
    }
    handleChange(event) {
    	var state = Object.assign({},this.props.mapDetails);
        var item = state;
        var value = event.target.value;
        var keys = event.target.name;

        //Checkboxes
        if(event.target.type == 'checkbox') {
            value = event.target.checked;
        }

        keys = keys.split('.');
        var iterations = keys.length - 1;
        for (var i = 0; i < iterations; i++) {
            item = item[keys.shift()];
        };

        switch(event.target.name) {
            default:
            	item[keys[0]] = value;
            	break
        }

        this.setState(state);
    }
    signin() {
    	var {username, password} = this.state;

      if(localStorage && this.state.remember_me) {
        localStorage.setItem('username', this.state.username)
      }
      if(!this.state.remember_me && localStorage) {
        localStorage.setItem('username', '');
      }

    	this.props.dispatch(login({username, password}, (error, success) => {

     		if(error)
    			this.setState({errors : [error]});
    		else {
    			if(typeof this.props.onSignin === 'function')
    				this.props.onSignin();

    			this.setState({messages : [{message: "Login Success!"}], errors : []});
    		}
    	}))
    }
    render() {
    	var {
    		errors,
    		messages,
    		username,
    		password
    	} = this.state;
        return <div>
        	{(()=>{
	    		if(errors.length > 0)
	    			return <div className="alert alert-danger">
						<button onClick={f => this.setState({errors : []})} type="button" className="close">×</button>
						<strong>Error!</strong>
						{errors.map(({message}) => (<p>{message}</p>))}
					</div>
        	})()}

			{(()=>{
	    		if(messages.length > 0)
	    			return <div className="alert alert-success">
						<button onClick={f => this.setState({messages : []})} type="button" className="close">×</button>
						{messages.map(({message}) => (<p>{message}</p>))}
					</div>
        	})()}

			{(()=>{
				if(errors.length > 0)
					return(
						<div className="alert alert-default">
							<p>Please Note: Usernames are case-sensitive.</p>
						</div>
					);
			})()}

			<div className="form-group mb-lg">
				<label>Username</label>
				<div className="input-group input-group-icon">
					<input
						onKeyDown={(event) => {if(event.key === 'Enter') {this.signin()}}}
						onChange={this.handleChange}
						value={username}
						name="username"
						type="text"
						className="form-control input-lg" />
					<span className="input-group-addon">
						<span className="icon icon-lg">
							<i className="fa fa-user"></i>
						</span>
					</span>
				</div>
			</div>

			<div className="form-group mb-lg">
				<div className="clearfix">
					<label className="pull-left">Password</label>
					<Link
						to="/password-reset-request"
						className="pull-right">Lost Password?
					</Link>
				</div>
				<div className="input-group input-group-icon">
					<input
						onKeyDown={(event) => {if(event.key === 'Enter') {this.signin()}}}
						onChange={this.handleChange}
						value={password}
						name="password"
						type="password"
						className="form-control input-lg" />
					<span className="input-group-addon">
						<span className="icon icon-lg">
							<i className="fa fa-lock"></i>
						</span>
					</span>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-8">
          <input type="checkbox" checked={this.state.remember_me} onChange={e => this.toggleRememberMe()} /> <label>Remember me.</label>
				</div>
				<div className="col-sm-4 text-right">
					<button onClick={this.signin} type="submit" className="btn btn-primary hidden-xs">Sign In</button>
					<button onClick={this.signin} type="submit" className="btn btn-primary btn-block btn-lg visible-xs mt-lg">Sign In</button>
				</div>
			</div>

        </div>;
    }
}

export default connect()(SigninForm);



// WEBPACK FOOTER //
// ./src/browser/components/sales/signinForm.js